import { axiosInstance } from "../../../config/api/Axios";

export const getReferralsApi = async (params) => axiosInstance.get("/admin/referrals", { params });
export const createReferralApi = async (data) => axiosInstance.post("/admin/referrals", data);
export const updateReferralApi = async (id, data) => axiosInstance.put(`/admin/referrals/${id}`, data);
export const deleteReferralApi = async (id) => axiosInstance.delete(`/admin/referrals/${id}`);
